(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('ContractAudit', ContractAudit);

    ContractAudit.$inject = ['$resource', 'DateUtils'];

    function ContractAudit ($resource, DateUtils) {
        var resourceUrl =  'jv/audit/contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                            angular.forEach(data, function( audit ) {
                                audit.commitMetadata.commitDate = DateUtils.convertDateTimeFromServer( audit.commitMetadata.commitDate );
                            })

                        //data.commitMeta = DateUtils.convertDateTimeFromServer(data.createdOn);
                        //data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                    }
                    return data;
                }
            },
            //'update': { method:'PUT' }
        });
    }
})();
